import User from "@/api/User";
import UserEmailAddress from "@/api/UserEmailAddress";
import UserAddress from "@/api/UserAddress";
import UserPhoneNumber from "@/api/UserPhoneNumber"
import UserExternalLink from "@/api/UserExternalLink"
import Application from "@/api/Application";
import Company from "@/api/Company";
import CompanyType from "../CompanyType";
import CompanyGroup from "../CompanyGroup";
import CompanyAddress from "../CompanyAddress";
import CompanyAddressPhoneNumber from "../CompanyAddressPhoneNumber";
import CompanyEmailAddress from "../CompanyEmailAddress";
import CompanyExternalLink from "../CompanyExternalLink";
import CompanyToba from "../CompanyToba";
import Role from "@/api/Role";
import Audit from "@/api/Audit";
import ExternalWebservice from "../ExternalWebservice";
import Log from "@/api/Log";
import LandingPagePersona from "@/api/Persona/LandingPage";
import FulwebPersona from "@/api/Persona/Fulweb";
import LearnDashPersona from "@/api/Persona/LearnDash";
import OrionPersona from "@/api/Persona/Orion";
import DataCentrePersona from "@/api/Persona/DataCentre";
import IprPlatformPersona from "@/api/Persona/IprPlatform";
import SyncUser from "@/api/Sync/SyncUser";
import SyncRole from "@/api/Sync/SyncRole";
import Report from "@/api/Report";
import UserLearningType from "@/api/UserLearningType";
import UserProfile from "@/api/UserProfile";
import RiskCode from "@/api/RiskCode";
import RiskCodeReference from "@/api/RiskCodeReference";
import ClientMap from "@/api/ClientMap";
import Product from "@/api/Product";
import ProductBundle from "@/api/ProductBundle";
import MappingRenewal from "@/api/MappingRenewal";
import CommercialProduct from "@/api/CommercialProduct";
import ProductOwner from "@/api/ProductOwner";
import CommercialClaim from "@/api/ClaimsNotifications/CommercialClaim";
import DynamicClaim from "@/api/ClaimsNotifications/Dynamic";
import StandardClause from "@/api/Product/StandardClause";
import Wording from "@/api/Product/Wording";
import FrontJacket from "@/api/Product/FrontJacket";
import RearJacket from "@/api/Product/RearJacket";
import LloydsRiskCode from "@/api/Product/LloydsRiskCode";
import LIORiskCode from "@/api/Product/LIORiskCode";
import InsuranceType from "@/api/Product/InsuranceType";
import ProductCategory from "@/api/Product/ProductCategory";
import Dynamic from "@/api/Product/Dynamic";
import Facility from "@/api/Facility";
import ClassOfBusiness from "@/api/Facility/ClassOfBusiness";
import Territory from "@/api/Facility/Territory";
import FacilityType from "@/api/Facility/FacilityType";
import ClassOfRisk from '@/api/Facility/ClassOfRisk';
import SectionClassificationType from '@/api/Facility/SectionClassificationType';
import InsurerRole from '@/api/Facility/InsurerRole';
import Administrators from "@/api/ContentManagement/Administrators";
import News from "@/api/ContentManagement/News";
import Nodes from "@/api/ContentManagement/Nodes";

import Auth from "../Auth";

class Manager {
  constructor() {
    this.users = User;
    this.userAddress = UserAddress;
    this.userEmailAddress = UserEmailAddress;
    this.userPhoneNumber = UserPhoneNumber;
    this.userLearningType = UserLearningType;
    this.userProfile = UserProfile;
    this.userExternalLink = UserExternalLink;
    this.companies = Company;
    this.companyTypes = CompanyType;
    this.companyGroups = CompanyGroup
    this.companyAddress = CompanyAddress;
    this.companyAddressPhoneNumber = CompanyAddressPhoneNumber;
    this.companyEmailAddress = CompanyEmailAddress;
    this.companyExternalLink = CompanyExternalLink;
    this.companyToba = CompanyToba;
    this.roles = Role;
    this.applications = Application;
    this.roles = Role;
    this.fulwebPersonas = FulwebPersona;
    this.learnDashPersonas = LearnDashPersona;
    this.landingPagePersonas = LandingPagePersona;
    this.orionPersonas = OrionPersona;
    this.dataCentrePersonas = DataCentrePersona;
    this.iprPlatformPersonas = IprPlatformPersona;
    this.externalWebservices = ExternalWebservice;
    this.logs = Log;
    this.audits = Audit;
    this.sync = {
      users: SyncUser,
      roles: SyncRole,
    }
    this.reports = Report;
    this.riskCode = RiskCode;
    this.riskCodeReference = RiskCodeReference;
    this.clientMap = ClientMap;
    this.products = Product;
    this.mappingRenewals = MappingRenewal;
    this.productBundles = ProductBundle;
    this.commercialProducts = CommercialProduct;
    this.productOwners = ProductOwner;
    this.commercialClaims = CommercialClaim;
    this.dynamicClaims = DynamicClaim;
    this.productWording = Wording;
    this.productStandardClause = StandardClause;
    this.productFrontJacket = FrontJacket;
    this.productRearJacket = RearJacket;
    this.productLloydsRiskCode = LloydsRiskCode;
    this.productLIORiskCode = LIORiskCode;
    this.productInsuranceType = InsuranceType;
    this.productCategory = ProductCategory;
    this.productDynamic = Dynamic;


    this.facilities = Facility;
    this.facilityClassOfBusiness = ClassOfBusiness;
    this.facilityClassOfRisk = ClassOfRisk;
    this.facilitySectionClassificationType = SectionClassificationType;
    this.facilityTerritory = Territory;
    this.facilityType = FacilityType;
    this.facilityInsurerRole = InsurerRole;

    this.contentManagementAdministrators = Administrators;
    this.contentManagementNews = News;
    this.contentManagementNodes = Nodes;
    this.auth = Auth;
  }
}

export default Manager;
